// Module
var code = "<div id=\"page-checkout\"> <div class=\"spinner-wrapper\"> <div class=\"no-show-ageloc spinner-page-loading\"> <img src=\"/content/dam/apps/checkout/spinner.gif\"> </div> </div> </div> ";
// Exports
module.exports = code;